<template lang="pug">
#ListNotes
  b-card.mm-3
    .table-view-header-title
      h3 Notas
      b-btn.boton(@click="showCreateModal()" size="sm" variant="secondary" style="float:left") + Añadir Nueva Nota
    hr
    .header
      .item
        h6(style="font-weight:bold;margin-right:10px") Ordenar por
        b-select.select(
          v-model="order"
          :options="getOrder()"
        )
      .item
        h6(style="font-weight:bold;margin-right:10px")    Encargado
        b-select.select(
          v-model="filterUser"
          :options="getCollaborators()"
        )
    hr
    .note-list(v-if="notes")
      div.notes-group(v-for="note in notes" :key="note.id")
        note-item(:note="note", :filterUser="filterUser", :order="order")

  b-modal(v-model="showCreate", :hide-footer="true", title="Crear Nueva Nota" no-close-on-backdrop)
    create-edit-form(v-if="showCreate", :hideModal="hideCreateModal", action="create", :makeToast="makeToast", :filterUser="filterUser", :order="order")
</template>

<script>
import CreateEditForm from './CreateEditForm'
import NoteItem from './NoteItem.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    CreateEditForm,
    NoteItem
  },
  data () {
    return {
      showCreate: false,
      showEdit: false,
      selectedNote: null,
      filterUser: null,
      order:'DESC'
    }
  },
  methods: {
    ...mapActions(['listNote', 'deleteNote', 'updateNote']),
    ...mapActions('UserStore',['listUsers']),
    async onUpdateNote (note) {
      console.log(note.done)
      await this.updateNote({ data: this.note, id: note.id })
      if(this.filterUser) {
        this.listNote({ userId: this.filterUser, order:this.order })
      }else{
        this.listNote({ userId: null, order:this.order })
      }
      this.editMode = false
    },
    async onDeleteNote (id) {
      const ok = await this.$bvModal.msgBoxConfirm('¿Está seguro de que desea eliminar esta nota?')
      if (ok) {
        const response = await this.deleteNote({ id: id })
        if (response.status === 200) {
          this.$root.$bvToast.toast('La nota se eliminó correctamente', {
          title: 'Éxito!!',
          variant: 'success'
        })
          this.$emit('done')
          if(this.filterUser) {
            await this.listNote({ userId: this.filterUser, order:this.order })
          }else{
            await this.listNote({ userId: null, order:this.order })
          }
          return
        }
        this.$root.$bvToast.toast('No se pudo eliminar', {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    showCreateModal() {
      this.showCreate = true;
    },
    async hideCreateModal() {
      this.showCreate = false;
      if(this.filterUser) {
        await this.listNote({ userId: this.filterUser, order:this.order })
      }else{
        await this.listNote({ userId: null, order:this.order })
      }
    },
    makeToast(variant=null, body, title) {
      this.$bvToast.toast(
        body,
        {
          title,
          variant,
          solid: true,
          hide: true,
          autoHideDelay: 3000
        }
      )
    },
    getCollaborators () {
      const collaboratorOptions = [{ text: 'Selecciona un Encargado.',value: null }]
      this.users.forEach(user => {
        if(user.role === 'collaborator' || user.role === 'owner'){
          collaboratorOptions.push({
            text: user.name +' '+ user.lastName,
            value: user.id
          })
        }
      })
      return collaboratorOptions
    },
    getOrder () {
      let values = [
        { text: 'Fecha de Creación (desc)', value: 'DESC' },
        { text: 'Mas antiguo (asc)', value: 'ASC' }
      ]
      return values
    }
  },
  computed: {
    ...mapGetters(['notes']),
    ...mapGetters('UserStore',['users']),
  },
  async created () {
    await this.listNote({ userId: this.filterUser, order:this.order })
    await this.listUsers()
  },
  watch: {
    filterUser () {
      this.listNote({ userId: this.filterUser, order:this.order })
    },
    order () {
      this.listNote({ userId: this.filterUser, order:this.order })
    }
  }
}
</script>

<style lang="scss" scoped>
.note-list {
  margin-top: 1rem;
  height: 500px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  overflow: auto;
}
.table-view-header-title {
  justify-content: space-between;
  margin: 2px 20px 20px 0px;
  align-items: center;
}
.header {
  display: inline-flex;
  margin: 20px auto;
  @media (max-width:768px){
    flex-direction: column
  }
}
hr {
  margin: auto -20px;
}
.item {
  display: inline-flex;
  align-items: baseline;
  @media (max-width:768px){
    flex-direction: column;
    h6 {
      margin-top: 8px;
    }
  }
  h6 {
    width: 185px;
    margin-right: 5px;
  }
  select {
    margin-right: 24px;
  }
}
</style>
